'use client';
import Link from 'next/link';
import React from 'react';
import { FiPhoneCall } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { Routes } from '@/settings/routes';
import { FaFacebook, FaInstagram, FaLinkedin, FaPinterest, FaRegEnvelope, FaXTwitter } from 'react-icons/fa6';
import { App_text } from '@/settings/AppText';
import { usePathname, useRouter } from 'next/navigation';

export default function TopBar() {
    const pathname = usePathname();
    const isHomePage = pathname === '/' || pathname === '/home';
    const bgClass = isHomePage ? 'bg-transparent relative z-[1]' : 'bg-secound-color';

    return (
        <div className={bgClass}>
            <div className="relative flex items-center w-full h-10 px-4 mx-auto max-w-8xl lg:px-8 lg:justify-between">
                <div className="items-center justify-between hidden w-full lg:flex">
                    <div className="items-center hidden gap-4 lg:flex">
                        <p className="block text-sm text-white md:hidden">{App_text.generale.call_us}:</p>
                        <Link prefetch={false} href={`tel:${Routes.FRONT_phone}`} passHref className="flex items-center gap-2 text-sm font-medium text-white transition-colors hover:text-main-color">
                            <FiPhoneCall className="w-4 h-4 text-main-color" />
                            {App_text.pages.contact_us.phone}
                        </Link>
                        <Link
                            prefetch={false}
                            href={`https://api.whatsapp.com/send?phone=${Routes.FRONT_whatsapp}`}
                            passHref
                            target="_blank"
                            className="flex items-center gap-2 text-sm font-medium text-white transition-colors hover:text-main-color"
                        >
                            <FaWhatsapp className="w-4 h-4 text-main-color" />
                            {App_text.pages.contact_us.whatsapp}
                        </Link>
                    </div>
                    <div className="items-center hidden gap-4 lg:flex">
                        <ul className="flex items-center gap-3">
                            <li className="pr-3 border-r border-gray-600">
                                <Link prefetch={false} href={Routes.FRONT_instagram} target="_blank" className="transition-colors text-main-color hover:text-main-color/80">
                                    <FaInstagram className="size-4" />
                                </Link>
                            </li>
                            <li className="pr-3 border-r border-gray-600">
                                <Link prefetch={false} href={Routes.FRONT_facebook} target="_blank" className="transition-colors text-main-color hover:text-main-color/80">
                                    <FaFacebook className="size-4" />
                                </Link>
                            </li>
                            <li className="pr-3 border-r border-gray-600">
                                <Link prefetch={false} href={Routes.FRONT_twitter} target="_blank" className="transition-colors text-main-color hover:text-main-color/80">
                                    <FaXTwitter className="size-4" />
                                </Link>
                            </li>
                            <li className="pr-3 border-r border-gray-600">
                                <Link prefetch={false} href={Routes.FRONT_Linkedin} target="_blank" className="transition-colors text-main-color hover:text-main-color/80">
                                    <FaLinkedin className="size-4" />
                                </Link>
                            </li>
                            <li className="pr-3 border-r border-gray-600">
                                <Link prefetch={false} href={Routes.FRONT_Pinterest} target="_blank" className="transition-colors text-main-color hover:text-main-color/80">
                                    <FaPinterest className="size-4" />
                                </Link>
                            </li>
                        </ul>
                        <Link prefetch={false} className="flex items-center gap-2 text-sm font-medium text-white transition-colors hover:text-main-color" href={Routes.FRONT_contact}>
                            <FaRegEnvelope className="w-4 h-4 text-main-color" />
                            {App_text.generale.contact_us}
                        </Link>
                    </div>
                </div>

                <div className="flex items-center justify-between w-full gap-2 lg:hidden">
                    <div className="flex items-center gap-2">
                        <p className="text-sm text-white">{App_text.generale.call_us}</p>
                        <ul className="flex items-center gap-3">
                            <li>
                                <Link prefetch={false} href={`tel:${Routes.FRONT_phone}`} passHref className="text-white transition-colors lg:hidden hover:text-main-color">
                                    <FiPhoneCall className="size-[1.2rem] text-main-color" />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    prefetch={false}
                                    href={`https://api.whatsapp.com/send?phone=${Routes.FRONT_whatsapp}`}
                                    passHref
                                    target="_blank"
                                    className="text-white transition-colors lg:hidden hover:text-main-color"
                                >
                                    <FaWhatsapp className="size-[1.2rem] text-main-color" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="flex items-center gap-4">
                        <Link prefetch={false} className="flex items-center gap-2 text-sm font-medium text-white transition-colors hover:text-main-color" href={Routes.FRONT_contact}>
                            <FaRegEnvelope className="size-[1.2rem] text-main-color" />
                            {App_text.generale.contact_us}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
